module.exports = __webpack_public_path__ + "static/media/1_1_jill_cress.c9cdb51.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/1_1_jill_cress.mp3
// module id = FTry
// module chunks = 1